import { render } from "./SpacingContent.vue?vue&type=template&id=048546f1"
import script from "./SpacingContent.vue?vue&type=script&lang=js"
export * from "./SpacingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__